import React from 'react';
import SMBaloonBaseView from 'components/shared/SMBaloonBaseView';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMUserBaloonView extends SMBaloonBaseView {
  
  render() {
    const user = this.props.user;
    let authRows = [];
    if (user.is_verified_facebook) {
      authRows.push(<p key="facebook" className="user-detail-baloon__auth">{I18n.t("dashboard.label_000098")}</p>);
    }
    if (user.is_verified_email) {
      authRows.push(<p key="email" className="user-detail-baloon__auth">{I18n.t("dashboard.label_000095")}</p>);
    }
    if (user.is_verified_tel) {
      authRows.push(<p key="tel" className="user-detail-baloon__auth">{I18n.t("dashboard.label_000096")}</p>);
    }
    
    return (
      <div ref="baloon" className="baloon baloon-top user-detail-baloon" 
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}>
        <div className="baloon-inner">
          <img src={SMFormatHelper.userImageUrl(user, user.profile_image)} className="user-detail-baloon__img" alt={user.contact_name} />
          <p className="user-detail-baloon__name">{user.contact_name}</p>
          <p className="user-detail-baloon__company">{user.corp_name}</p>
          {authRows}
          <a target="_blank" href={this.props.buttonLink} className="button-blue user-detail-baloon__button">{this.props.buttonTitle}</a>
        </div>
      </div>
    );
  }
}
export default SMUserBaloonView;



// WEBPACK FOOTER //
// ./app/javascript/components/users/SMUserBaloonView.jsx